const regionsModel = vm => ({
  title: vm.$gettext('Regions'),
  endpoint: 'regions',
  allowNew: true,
  countrize: 'country_iso_code',
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'name',
      label: vm.$gettext('Name'),
      sortable: true,
      editable: true,
      required: true
    },
    {
      key: 'country_iso_code',
      label: vm.$gettext('Country ISO Code'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext('Country (2 letter ISO code)')
    },
    {
      key: 'type',
      label: vm.$gettext('Type'),
      editable: true,
      required: true,
      description: vm.$gettext('Region type (ie. company_management)')
    }
  ],
  filters: ['id', 'name', 'country_iso_code', 'type'],
  includes: ['areas']
})

export default regionsModel
